import displayList from './modules/display-movies';
import './styles/style.css';

displayList();
